import { useQuery } from '@tanstack/react-query'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import api from '@/lib/api'

export type ProductHistoryItem = {
  id: string
  action: string
  timestamp: string
  id_product: string
  id_tenant: string
  details?: {
    summary?: Record<string, any>
    [key: string]: any
  }
  actor?: {
    id: string
    name: string
    email: string
    typeCargo: string
    typeUser: string
  } | null
}

export function useFetchProductHistory(productId?: string) {
  const token = useAccessToken()
  const user = useCurrentUser()
  const enabled = Boolean(productId && token && user)

  return useQuery<ProductHistoryItem[]>({
    queryKey: ['product-history', productId],
    enabled,
    queryFn: async () => {
      if (!productId) throw new Error('ID do produto não informado')
      const response = await api.get(`/products/history/${productId}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      return Array.isArray(response.data?.data) ? response.data.data : []
    }
  })
}
